import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'Context/QueryClientContext';
import { IObraResponse } from 'Data/interfaces/Obra/IObraListResponse';
import toastHandler from 'Utils/toastHandler';
import { OBRA_QUERY_KEY } from 'Data/keys/QueryKeys';
import { ObrasApiV2 } from 'Data/Obras.api.v2';
import { IObraUsersRequest } from 'Data/interfaces/Obra/IObraUsers';
import { ISharedUser } from 'Data/interfaces/User/ISharedUser';

export const useQueryDeleteUsersObra = () => {
  const { mutate, isPending } = useMutation({
    mutationFn: (variables: IObraUsersRequest) => {
      return ObrasApiV2.deleteUsers(variables);
    },
    onMutate: async (variables) => {
      const previousObras = queryClient.getQueryData<IObraResponse[]>(
        [OBRA_QUERY_KEY],
      );
      const previousUniqueObra = queryClient.getQueryData<IObraResponse>(
        [OBRA_QUERY_KEY, Number(variables.constructionStieId)],
      );

      queryClient.setQueryData([OBRA_QUERY_KEY], (
        oldData: IObraResponse[],
      ) => {
        return oldData?.map((obra) => {
          if (obra.ConstructionSiteId === variables.constructionStieId) {
            return {
              ...obra,
              SharedUsers: obra.SharedUsers?.filter((user: ISharedUser) => {
                return user.UserFk !== variables.userId && user.UserId !== variables.userId;
              }),
            };
          }
          return obra;
        });
      });
      queryClient.setQueryData([OBRA_QUERY_KEY, Number(variables.constructionStieId)], (
        oldData: IObraResponse,
      ) => {
        if (oldData.ConstructionSiteId === variables.constructionStieId) {
          return {
            ...oldData,
            SharedUsers: oldData.SharedUsers?.filter((user: ISharedUser) => {
              return user.UserFk !== variables.userId && user.UserId !== variables.userId;
            }),
          };
        }
        return oldData;
      });

      return { previousObras, previousUniqueObra };
    },
    onSuccess: () => {
      toastHandler.showSuccess('Compartilhamento da Obra removido com sucesso!');
    },
    onError: async (error: any, variables, context) => {
      await Promise.all([
        queryClient.cancelQueries({ queryKey: [OBRA_QUERY_KEY] }),
        queryClient.cancelQueries({
          queryKey: [OBRA_QUERY_KEY, Number(variables.constructionStieId)],
        }),
      ]);

      queryClient.setQueryData([OBRA_QUERY_KEY], context?.previousObras);
      queryClient.setQueryData(
        [OBRA_QUERY_KEY, Number(variables.constructionStieId)],
        context?.previousUniqueObra,
      );

      const errorMsg = error.errors
        ? error.errors[0].Message
        : 'Erro ao remover compartilhamento da Obra!';
      toastHandler.showError(errorMsg);
    },
  });

  return {
    deleteUsersObra: mutate,
    isLoading: isPending,
  };
};
